import axiosInstance from './axiosInstance';

const alertService = {
    createAlert: async (alertData) => {
        const response = await axiosInstance.post('/alerts', alertData);
        return response.data;
    },
    getAlerts: async () => {
        const response = await axiosInstance.get('/alerts');
        return response.data;
    },
    toggleAlertStatus: async (alertId) => {
        const response = await axiosInstance.patch(`/alerts/${alertId}/toggle`);
        return response.data;
    },
    getMyAlerts: async () => {
        const response = await axiosInstance.get('/alerts/my-alerts');
        return response.data;
    },
    acknowledgeAlert: async (alertId) => {
        const response = await axiosInstance.post(`/alerts/${alertId}/acknowledge`);
        return response.data;
    }
};

export default alertService;
